export var toastContainerBottomPixels = '32px';
export var toastContainerPaddingTopPixels = '8px';
export var toastContainerPaddingRightPixels = '8px';
export var toastContainerPaddingBottomPixels = '8px';
export var toastContainerPaddingLeftPixels = '12px';
export var toastContainerMaxWidthPixels = '320px';
export var toastContainerMinWidthPixels = '260px';
export var toastLabelPaddingVerticalPixels = '0px';
export var toastLabelPaddingHorizontalPixels = '4px';
export var toastLabelMarginLeftPixels = '4px';
export var toastButtonMarginLeftPixels = '12px';
export var toastButtonPaddingVerticalPixels = '0px';
export var toastButtonPaddingHorizontalPixels = '8px';
// TODO: Should these colors come from Fluent palette?
export var successIconPrimaryFillColor = '#92C353';
export var errorIconPrimaryFillColor = '#D74553';
//# sourceMappingURL=constants.js.map